import IndicatorBLock from '@/domain/scene/indicators/generic/IndicatorBlock.js'
import { numbFormat } from '@/domain/helpers/MathHelper.js'
import {
  travelTime as relativisticTravelTime,
  timeDilation,
  remoteClockTime
} from '@/domain/physics/SpecialRelativity.js'
import { travelTime as classicalTravelTime } from '@/domain/physics/ClassicalMechanics.js'

const WIDTH_REL = 0.036
const HEIGHT_REL = 0.042

export default class ClockIndicator extends IndicatorBLock {
  constructor (name, initXRel, initYRel, clockPos, clockParent) {
    super(
      name,
      WIDTH_REL,
      HEIGHT_REL,
      initXRel,
      initYRel
    )
    this.clockPos = clockPos
    this.clockParent = clockParent
  }

  getTextConfig () {
    return {
      x: this.x,
      y: this.y + this.height * 0.15,
      width: this.width,
      text: this.text,
      lineHeight: 1.4,
      fill: 'white',
      fontSize: this.fontSize,
      align: 'center'
    }
  }

  setValue (isObserverInTrain, oppositeObjPos, isRelativistic, speedValue) {
    let isClockInTrain = (this.clockParent === 'train')
    let timeValue

    if (isRelativistic) {
      if ((isObserverInTrain && !isClockInTrain) || (!isObserverInTrain && isClockInTrain)) {
        let tt = relativisticTravelTime((isClockInTrain ? 1 : -1) * oppositeObjPos, speedValue)
        let dilatedTime = timeDilation(tt, speedValue)
        let rct = remoteClockTime(this.clockPos, dilatedTime, speedValue)
        timeValue = numbFormat(rct)
      } else {
        timeValue = numbFormat(relativisticTravelTime((isClockInTrain ? -1 : 1) * oppositeObjPos, speedValue))
      }
    } else {
      if ((isObserverInTrain && !isClockInTrain) || (!isObserverInTrain && isClockInTrain)) {
        timeValue = numbFormat(classicalTravelTime((isClockInTrain ? 1 : -1) * oppositeObjPos, speedValue), 1)
      } else {
        timeValue = numbFormat(classicalTravelTime((isClockInTrain ? -1 : 1) * oppositeObjPos, speedValue), 1)
      }
    }

    let timeUnit = isRelativistic ? 'ns' : 's'
    this.text = `${timeValue} ${timeUnit}`
  }
}
